<template>
  <div>
    <user-detail-title
        first-bread="售后服务"
        second-bread="售后服务添加"
        first-url="/user/service"
        title-name="售后服务添加"
    />
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="Alist.name" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="文件描述">
          <el-input v-model="Alist.description" type="textarea" :rows="10" style="width: 500px;"></el-input>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "@/views/User/Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "ServiceAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Alist: {
          'name':null,
          'photoUrl':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    methods:{
      GetUrlList(file){
        this.Alist.photoUrl=file.data;
      },
      handleAdd(){
        this.$axios.post('/api/after/add',this.Alist).then(res=>{
          if(res.data.success == true){
            this.Alist= {
              'name':null,
              'photoUrl':null,
              'description':null,
            }//表示Add添加的数据,
            this.$message({
              message:'添加成功',
              type:'success'
            })
          }
        })
      }
    },
  }
</script>

<style scoped>

</style>